import React from 'react';
import { LanguageProvider } from './i18n/LanguageContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { WhyKorean } from './components/WhyKorean';
import { Trust } from './components/Trust';
import { Philosophy } from './components/Philosophy';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { BookingForm } from './components/BookingForm';
import { Footer } from './components/Footer';
import { SectionDivider } from './components/SectionDivider';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <Hero />
        <SectionDivider />
        <WhyKorean />
        <SectionDivider />
        <Trust />
        <SectionDivider />
        <Philosophy />
        <SectionDivider />
        <Services />
        <SectionDivider />
        <Gallery />
        <Testimonials />
        <SectionDivider />
        <BookingForm />
        <Footer />
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
